import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '../contentful.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  constructor(private contentful: ContentfulService) { }

  ngOnInit() {
    console.log(this.contentful.getProductsByCategory('6tPz2Y1mo0euC0UGoMemka'));
  }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/home/home.component.ts